import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  object-fit: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { useState, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { border, shadow, color, background } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '../grid/Grid';
import DEFAULT_COVER from './defaultCover.jpg';
var FIT_MAP = {
  cover: 'cover',
  contain: 'contain'
};
var fitStyle = css(_templateObject(), function (props) {
  return FIT_MAP[props.fit];
});
var StyledImage = styled.img(_templateObject2(), border, shadow, color, background, function (props) {
  return props.fit && fitStyle;
});
export var Image =
/*#__PURE__*/
forwardRef(function (_ref, ref) {
  var src = _ref.src,
      fallbackSrc = _ref.fallbackSrc,
      onError = _ref.onError,
      props = _objectWithoutProperties(_ref, ["src", "fallbackSrc", "onError"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      imageMissing = _useState2[0],
      setImageMissing = _useState2[1];

  var handleError = function handleError(event) {
    if (onError) {
      onError(event);
    }

    setImageMissing(true);
  };

  return (
    /*#__PURE__*/
    React.createElement(Box, _extends({}, props, {
      as: StyledImage,
      ref: ref,
      src: !imageMissing ? src : fallbackSrc,
      onError: (onError || fallbackSrc) && handleError
    }))
  );
});
Image.defaultProps = {
  fit: 'cover',
  fallbackSrc: DEFAULT_COVER,
  alt: ''
};
Image.displayName = 'Image';